var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M170.34,0a64,64,0,1,1-64,64,64,64,0,0,1,64-64m48,144H207a87.91,87.91,0,0,1-73.28,0H122.34a48,48,0,0,0-48,48V328a24,24,0,0,0,24,24h16V488a24,24,0,0,0,24,24h64a24,24,0,0,0,24-24V352h16a24,24,0,0,0,24-24V192A48,48,0,0,0,218.34,144Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M421.14,339.73H389.52V172.27h31.62c14.68,0,22-17.75,11.66-28.13L373.7,85a16.48,16.48,0,0,0-23.3,0l-59.1,59.1c-10.38,10.38-3,28.13,11.66,28.13h31.62V339.73H303c-14.68,0-22,17.75-11.66,28.13L350.4,427a16.48,16.48,0,0,0,23.3,0l59.09-59.1c10.39-10.38,3-28.13-11.65-28.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.b7d4dabb5353a566497409fe2cd80735.svg";
export { ForwardRef as ReactComponent };